// A labelled native file picker. The platform's own chooser (camera, photos, files) is the right
// one on a phone, so this only wraps it in a Field and hands the chosen file to the caller.
import "./config";
import { View, styled } from "tamagui";
import { Field } from "./forms";

const Native = styled(View, {
  name: "FileInput",
  render: "input",
  width: "100%",
  minWidth: 0,
  color: "text",
  fontFamily: "body",
  fontSize: "3",
});

export interface FileInputProps {
  label: string;
  /** The `accept` filter, e.g. `image/*`. */
  accept?: string;
  hint?: string | undefined;
  error?: string | undefined;
  hideLabel?: boolean;
  id?: string | undefined;
  onFile: (file: File) => void;
}

export function FileInput({
  label,
  accept,
  hint,
  error,
  hideLabel = false,
  id,
  onFile,
}: FileInputProps): React.JSX.Element {
  return (
    <Field label={label} hint={hint} error={error} id={id} hideLabel={hideLabel}>
      {(aria) => {
        // Tamagui's props do not list the input attributes, so they travel as a spread.
        const native = {
          type: "file",
          ...(accept === undefined ? {} : { accept }),
          onChange: (event: React.ChangeEvent<HTMLInputElement>): void => {
            const file = event.target.files?.[0];
            if (file !== undefined) onFile(file);
          },
        };
        // nosemgrep: rules.typescript.react.best-practice.react-props-spreading -- props are typed as the component's own
        return <Native {...native} {...aria} />;
      }}
    </Field>
  );
}
